import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["logo", "link", "dropdown"];

  activateRoot(event) {
    this.linkTargets.forEach((link, index) => {
      link.dataset.active = index === 0;
    });
    event.currentTarget.dataset.inactive = true;
  }

  activateLink(event) {
    const index = this.linkTargets.indexOf(event.currentTarget);
    this.logoTarget.dataset.inactive = index === 0;

    this.linkTargets.forEach((link) => {
      link.dataset.active = link === event.currentTarget;
      link.dataset.selected = link === event.currentTarget;
    });
  }

  hideDropdownMenu() {
    const dropdownMenu = this.dropdownTarget.querySelector(
      '[data-ui-kit--dropdown-target="menu"]',
    );
    dropdownMenu.dataset.hidden = true;
  }
}
